// src/components/SwitchTenantModal.js
import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

const SwitchTenantModal = ({ onClose }) => {
  const { tenantList, selectedTenantId, switchTenant } = useAuth();
  const [selected, setSelected] = useState(selectedTenantId);

  const handleSave = () => {
    if (selected && selected !== selectedTenantId) {
      switchTenant(selected);
      localStorage.setItem("selectedTenantId", selected);
      window.location.reload(); // Reload to apply new tenant
    }
  };

  return (
    <Modal show onHide={onClose} size="sm">
      <Modal.Header closeButton>
        <Modal.Title>Switch Tenant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Select value={selected} onChange={e => setSelected(e.target.value)}>
          <option value="">Select Tenant</option>
          {tenantList.map(t => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
        </Form.Select>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleSave}>Switch</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SwitchTenantModal;
